import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
	selector: "app-pagination",
	templateUrl: "./pagination.component.html",
	styleUrls: ["./pagination.component.scss"],
})
export class PaginationComponent {
	@Input() itemCount: number;
	@Input() currentPage: number;
	@Input() pageLength: number;
	@Output() pageTo: EventEmitter<number> = new EventEmitter();

	get totalPages(): number {
		return Math.ceil(this.itemCount / this.pageLength);
	}

	get pages(): any[] {
		return Array(this.totalPages);
	}

	constructor() {}

	doPageTo(num: number): void {
		this.pageTo.emit(num);
	}
}
